import request from '../httpClient';

// tslint:disable
export const getOtaAccounts = (params: any) =>
  request.get('/ota_accounts', params);

export const createOtaAccount = (body: any) =>
  request.post('/ota_accounts', body);

export const updateOtaAccount = (otaAccountId: number, body: any) =>
  request.put(`/ota_accounts/${otaAccountId}`, body);

export const getOtaAccount = (otaAccountId: number) =>
  request.get(`/ota_accounts/${otaAccountId}`);

export const removeOtaAccount = (otaAccountId: number) =>
  request.delete(`/ota_accounts/${otaAccountId}`);



// WEBPACK FOOTER //
// ./src/services/api/otaAccountApi.ts